import {
  Dialog,
  Transition,
  TransitionChild,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import axios from "axios";
import { Fragment, useState } from "react";
import { toast } from "sonner";

const VerifyEmailDialog = ({ isOpen, onClose, email = "user@upswap.app" }) => {
  const [code, setCode] = useState("");

  const handleVerify = async () => {
   
    const payload = {
      verification_type: "email",
      email: email,
      otp: code,
    };
    try {
      const response = await axios.post(
        "https://api.upswap.app/api/verify-otp/v2/",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access")}`,
          },
        }
      );

      if (response.status === 200) {
        toast.success("Email updated successfully!");
      } else {
        throw new Error(response.data.detail || "Failed to update Email");
      }
    } catch (err) {
      toast.error(err.response?.data?.detail || "Failed to update Email.");
    } finally {
      onClose();
    }
  };

  const handleResend = () => {
    // Handle resend logic
    alert("Verification code resent to " + email);
  };

  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={onClose}>
        <TransitionChild
          as={Fragment}
          enter="ease-out duration-300"
          leave="ease-in duration-200"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-30" />
        </TransitionChild>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center px-4 py-8">
            <TransitionChild
              as={Fragment}
              enter="ease-out duration-300"
              leave="ease-in duration-200"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <DialogPanel className="w-full max-w-sm transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                <DialogTitle
                  as="h3"
                  className="text-xl font-semibold text-gray-900 flex justify-between items-center"
                >
                  Verify Email
                  <button
                    onClick={onClose}
                    className="text-gray-500 hover:text-gray-800 text-xl font-bold"
                  >
                    &times;
                  </button>
                </DialogTitle>

                <div className="mt-4 bg-orange-50 text-orange-700 p-3 rounded-lg text-sm">
                  We've sent a verification code to your email
                  <br />
                  <span className="font-medium">{email}</span>
                </div>

                <div className="mt-5">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Enter Verification Code
                  </label>
                  <input
                    type="text"
                    maxLength={6}
                    value={code}
                    onChange={(e) => setCode(e.target.value)}
                    className="w-full text-center text-2xl font-medium tracking-widest border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
                    placeholder="000000"
                  />
                </div>

                <div className="mt-3">
                  <button
                    onClick={handleResend}
                    className="text-sm text-orange-600 hover:underline"
                  >
                    Resend Code
                  </button>
                </div>

                <button
                  onClick={handleVerify}
                  className="mt-5 w-full bg-orange-400 hover:bg-orange-500 text-white font-semibold py-2 rounded-lg transition"
                >
                  Verify
                </button>
              </DialogPanel>
            </TransitionChild>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};

export default VerifyEmailDialog;
